import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { getVentilstilling } from "../../../actions/ventilstillingerActions";
import * as title from "../../../constants/titles";
import Ventilstillingsdetail from "./Ventilstillingsdetail";

function VentilstillingsdetaljPage() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const ventilstilling = useSelector((state) => state.ventilstilling);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = title.ventilstillingsdetalj(ventilstilling.ileggelsesnummer);
    dispatch(getVentilstilling(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = title.ventilstillingsdetalj(ventilstilling.ileggelsesnummer);
  }, [ventilstilling.ileggelsesnummer]);

  if (id === ventilstilling.id) {
    return <Ventilstillingsdetail ventilstilling={ventilstilling} />;
  }
  return <span />;
}

export default VentilstillingsdetaljPage;
